import { faEnvelope, faMobile } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import oftmcssLogo from '../../../media/oftmcss.svg'
import { ConditionalRoute } from '../../../routes'
import { isAuthenticated } from 'session'
import { IStoreState } from '../../../store'
import { Content, Templates } from 'ui'
import { ProfileCompleteView } from '../ProfileCompleteView'
import { ConfirmationView } from './ConfirmationView'
import { EducatorStepOne } from './EducatorStepOne'
import { EducatorStepTwo } from './EducatorStepTwo'
import { ProfessionalStepOne } from './ProfessionalStepOne'
import { ProfessionalStepTwo } from './ProfessionalStepTwo'

const EduBody: React.FC = () => (
  <Content.Body>
    So that our Educator PRO Connect platform can best match professionals to
    support you, please complete the following profile. Your choices are taken
    from the{' '}
    <a href="https://www.azed.gov/standards-practices/">
      AZ Department of Education K-12 Standards
    </a>
    , which will be matched with occupations taken from the
    <a href="https://www.bls.gov/jobs/">U.S Bureau of Labor Statistics</a>.
    Please note that your choices of <strong>Connection Activities</strong> and{' '}
    <strong>City Preference</strong> and <strong>Key Words</strong>
    will allow for a better match. Also, pictures are welcome to be uploaded
    into your profile!
  </Content.Body>
)

const ProBody: React.FC = () => (
  <Content.Body>
    So that our Educator PRO Connect platform can best match educators with your
    expertise, please complete the following profile. The choices of occupations
    are taken from the{' '}
    <a href="https://www.bls.gov/jobs/">U.S Bureau of Labor Statistics</a>.
    Please note that your choice of <strong>Connection Activities</strong> and{' '}
    <strong>City Preference</strong> and <strong>Key Words</strong> that
    indicate your interests will allow for a better match. Also, pictures are
    welcome to be uploaded into your profile!
  </Content.Body>
)

/**
 * The internal layout for the account creation process.
 */
export const CreateAccountLayout: React.FC = () => (
  <Templates.MinimalistView
    footerImageSrc={oftmcssLogo}
    splashContent={
      <Content.Region>
        <Content.Heading>Build Your Profile</Content.Heading>
        <Switch>
          <Route path="/signup/educator" component={EduBody} />
          <Route path="/signup/professional" component={ProBody} />
        </Switch>
        <Content.SubHeading>Questions?</Content.SubHeading>
        <Content.Body>Don’t hesitate to get in touch:</Content.Body>
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faMobile} />
            </Content.ListIcon>
            <Content.Href href="tel:6025063866">(602) 506-3866</Content.Href>
          </Content.ListItem>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faEnvelope} />
            </Content.ListIcon>
            <Content.Href href="mailto:stempro@maricopa.gov">
              stempro@maricopa.gov
            </Content.Href>
          </Content.ListItem>
        </Content.List>
      </Content.Region>
    }
  >
    <Switch>
      <Route path="/signup/confirm" component={ConfirmationView} exact={true} />
      <Route
        path="/signup/educator/one"
        component={EducatorStepOne}
        exact={true}
      />
      <Route
        path="/signup/educator/two"
        component={EducatorStepTwo}
        exact={true}
      />
      <Route
        path="/signup/professional/one"
        component={ProfessionalStepOne}
        exact={true}
      />
      <Route
        path="/signup/professional/two"
        component={ProfessionalStepTwo}
        exact={true}
      />
      <Redirect to="/" />
    </Switch>
  </Templates.MinimalistView>
)

/**
 * The default router exposed as the entrypoint to this series
 * of related views.
 */
const CreateAccountRouter: React.FC<{ authenticated: boolean }> = ({
  authenticated,
}) => {
  const loggedIn = () => authenticated
  const loggedOut = () => !loggedIn()
  return (
    <Switch>
      <ConditionalRoute
        path="/signup/confirm"
        component={ConfirmationView}
        redirectIf={loggedIn}
        redirectPath="/signup"
      />
      <ConditionalRoute
        path="/signup/complete"
        component={ProfileCompleteView}
        redirectIf={loggedOut}
        redirectPath="/signup"
      />
      <Route path="/signup" component={CreateAccountLayout} />
    </Switch>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  authenticated: isAuthenticated(state.session),
})

export const CreateAccountView = connect(mapStateToProps)(CreateAccountRouter)
